// Vue
import Vue from 'vue'

export const registerFilters = (filters: {[name: string]: any}) => {
    Object.keys(filters).forEach(name => {

        const prefix = APP_PREFIX.toLowerCase()

        Vue.filter(`${prefix}${name}`, filters[name])
    })
}